import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AndroidOutlinedSvg from "@ant-design/icons-svg/es/asn/AndroidOutlined";
import AntdIcon from '../components/AntdIcon';
var AndroidOutlined = function AndroidOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: AndroidOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(AndroidOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'AndroidOutlined';
}
export default RefIcon;